import styled from 'styled-components'

export const ImgDiv = styled.div`

    line-height: 0%;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`